import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators'
import { TCCPHttpService } from '../../services/tccp-http.service';
import { TCCPConstantValues } from '../../models/tccp-constants';
import { TCCPLoggerService } from '../../services/tccp-logger.service';
import { environment } from '../../../../environments/environment';
import { LoaderService } from '../../loader/loader.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Utilities } from '../../utilities';

@Injectable({
  providedIn: 'root'
})
export class PhoneCompatabilityService {

  constructor(
    private httpService: TCCPHttpService, private http: HttpClient,
    private logger: TCCPLoggerService, private loaderService: LoaderService) { }

  public bluetoothCompatibilityURL = Utilities.getBluetoothExternalPath();
  public appBase = TCCPConstantValues[environment.applicationName];


  getPhoneCompatabilityList(headUnitConfig: string, year: string): Observable< any > {
    this.logger.logMethodStart(this.appBase.modules.BLUETOOTH_COMPATABILTITY_MODLE, this.appBase.methods.getPhoneCompatabilityList,
      'Started getting Phone Compatability', '');
    const url = this.bluetoothCompatibilityURL + '/features/' + headUnitConfig + '/' + year;
    const headersObj = new HttpHeaders({ nameCode: 'CCP', 'Content-Type': 'application/json' });
    return this.http.get(url, { headers: headersObj }).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.BLUETOOTH_COMPATABILTITY_MODLE, url,
            'Getting Phone Compatability successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.BLUETOOTH_COMPATABILTITY_MODLE, this.appBase.methods.getPhoneCompatabilityList,
            'Getting Phone Compatability failed', '', error);
          return error;
        })
    );
  }

  getModelsByDivisions(model: string, year: number): Observable< any > {
    this.logger.logMethodStart(this.appBase.modules.BLUETOOTH_COMPATABILTITY_MODLE, this.appBase.methods.getPhoneCompatabilityList,
      'Started getting Phone Compatability', '');
    const url = this.bluetoothCompatibilityURL + '/divisions/' + model + '/' + year;
    const headersObj = new HttpHeaders({ nameCode: 'CCP', 'Content-Type': 'application/json' });
    return this.http.get(url, { headers: headersObj }).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.BLUETOOTH_COMPATABILTITY_MODLE, url,
            'Getting Phone Compatability successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.BLUETOOTH_COMPATABILTITY_MODLE, this.appBase.methods.getPhoneCompatabilityList,
            'Getting Phone Compatability failed', '', error);
          return error;
        })
    );
  }

  getPhoneCompatabilityListByHUPhoneConfigId(headUnitConfig: string, year: string): Promise< any > {
    this.logger.logMethodStart(this.appBase.modules.BLUETOOTH_COMPATABILTITY_MODLE, this.appBase.methods.getPhoneCompatabilityList,
      'Started getting Phone Compatability', '');
    const url = `${this.bluetoothCompatibilityURL}/compatibility/${headUnitConfig}/${year}`;
    const headersObj = new HttpHeaders({ nameCode: 'CCP', 'Content-Type': 'application/json' });
    return this.http.get(url, { headers: headersObj }).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.BLUETOOTH_COMPATABILTITY_MODLE, url,
            'Getting Phone Compatability successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.BLUETOOTH_COMPATABILTITY_MODLE, this.appBase.methods.getPhoneCompatabilityList,
            'Getting Phone Compatability failed', '', error);
          return error;
        })).toPromise();
  }


  getHeadUnitInfo(requestData): Observable< any > {
    this.logger.logMethodStart(this.appBase.modules.BLUETOOTH_COMPATABILTITY_MODLE, this.appBase.methods.getPhoneCompatabilityList,
      'Started getting Phone Compatability', '');
    const url = this.bluetoothCompatibilityURL + '/headunits';
    const headersObj = new HttpHeaders({ nameCode: 'CCP', 'Content-Type': 'application/json' });
    return this.http.post(url, requestData, { headers: headersObj }).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.BLUETOOTH_COMPATABILTITY_MODLE, this.appBase.methods.getPhoneCompatabilityList,
            'Getting Phone Compatability successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.BLUETOOTH_COMPATABILTITY_MODLE, this.appBase.methods.getPhoneCompatabilityList,
            'Getting Phone Compatability failed', '', error);
          return error;
        })
    );
  }

}
